module.exports = __webpack_public_path__ + "img/result.cdf9317a.png";